/**
 * Integration types and constants shared across the application
 *
 * This file contains the core integration definitions that are used
 * consistently across different components and features.
 */

/**
 * Mapping of internal short keys to backend integration identifiers
 * Used for consistent reference to integrations throughout the component
 * - Z: Zoom video conferencing
 * - G: Google Calendar
 * - M: Microsoft Calendar
 * - S: Slack messaging
 * - GO: Gong call recording
 */
export const IntegrationKeys = {
  Zoom: 'zoom',
  GoogleCalendar: 'googleCalendar',
  MicrosoftCalendar: 'microsoftCalendar',
  Slack: 'slack',
  Gong: 'gong',
} as const

/**
 * Reverse mapping from backend keys to display keys
 * Used to convert backend integration identifiers to display names
 */
export const IntegrationKeysMap = {
  googleCalendar: 'GoogleCalendar',
  microsoftCalendar: 'MicrosoftCalendar',
  zoom: 'Zoom',
  slack: 'Slack',
  gong: 'Gong',
}

/**
 * Type for integration keys
 */
export type IntegrationKey = (typeof IntegrationKeys)[keyof typeof IntegrationKeys]

/**
 * Personal integrations that are specific to individual users
 * These are managed at the user level
 */
export const personalIntegrations: IntegrationKey[] = [
  IntegrationKeys.GoogleCalendar,
  IntegrationKeys.MicrosoftCalendar,
  IntegrationKeys.Zoom,
]
